<template>
  <div>
    <Page title="アクセス履歴">
      <template v-slot:content>
        <div class="table-action">
          <form class="serach-form" @submit.prevent="onAccessLogSearch()">
            <div class="serach-items">
              <div class="serach-header">期間:</div>
              <Datepicker
                width="180"
                class="uk-input start-date"
                v-model="FormValues.startDate"
                :locale="locale"
                input-format="yyyy-MM-dd"
                :weekStartsOn="0"
                placeholder="From"
                :clearable="true"
              />
              <div>〜</div>
              <Datepicker
                class="uk-input end-date"
                v-model="FormValues.endDate"
                :locale="locale"
                input-format="yyyy-MM-dd"
                :weekStartsOn="0"
                placeholder="To"
                :clearable="true"
              />
              <div class="serach-header">画面:</div>
              <select class="uk-select serach-box page-ids" v-model="FormValues.pageId">
                <option value=""></option>
                <option v-for="pageId in pageIds" :key="pageId.key" :value="pageId.key">
                  {{ pageId.name }}
                </option>
              </select>
              <div class="serach-header">ワード:</div>
              <input
                class="uk-input serach-box name"
                type="text"
                v-model="FormValues.name"
                placeholder="部分一致"
                @keydown.enter="onAccessLogSearch()"
              />
              <div class="right-contents">
                <ActionButton title="検索" color="primary" type="submit" :width="110" />
                <ActionButton title="クリア" color="default" type="button" @click="resetConditions" :width="110" />
              </div>
            </div>
          </form>
        </div>
        <div class="uk-card uk-card-default uk-card-body">
          <Table ref="tableComponent" :header="header" :callback="getTableData" />
        </div>
      </template>
    </Page>
  </div>
</template>
<style lang="scss" scoped>
@include table-action;
@include modal-form;
.table-action > form > div {
  display: flex;
  justify-content: flex-end;
}
.table-sub-action {
  display: flex;
  justify-content: flex-end;
  margin-bottom: $spacing-small;
  font-size: 0.7rem;
}
.search-field {
  margin-right: $spacing-medium;
}
.excel-button {
  margin-left: $spacing-small;
}
.display-info,
.display-limit,
.table-action > form > div.serach-items {
  display: flex;
  flex-direction: row;
  align-items: center;
  vertical-align: center;
  text-align: left;
  margin-right: auto;
  justify-content: flex-start;
}
.display-limit {
  margin-left: 30px;
  & > label {
    margin-right: 16px;
  }
}
.serach-items {
  // min-width: 1100px;
  font-size: 12px;
  .serach-header {
    word-break: keep-all;
  }
  .serach-box {
    box-sizing: border-box;
    margin-right: $spacing-ex-small;
  }
  .name {
    width: 12em;
  }
  .page-ids {
    width: 20em;
  }
  div.v3dp__datepicker {
    width: 13em;
    &:deep(div.v3dp__clearable) {
      position: absolute;
      right: 9px;
      top: 10px;
      left: unset;
      cursor: pointer;
    }
  }
  & > div {
    margin-right: 6px;
  }
  .right-contents {
    display: flex;
    margin: 0 0 0 auto;
    & > button:first-child {
      margin-right: 6px;
    }
  }
}
</style>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { AccessLogApi, AuthApi, AccessLog, PageId } from "../../autogen";
import Page from "../molecules/Page.vue";
import ActionButton from "../atoms/ActionButton.vue";
import Table from "../molecules/Table.vue";
import moment from "moment-timezone";
import Store from "../../store";
import Datepicker from "vue3-datepicker";
import { ja } from "date-fns/locale";
type FormValues = {
  name?: string;
  startDate?: Date;
  endDate?: Date;
  pageId?: string;
};
@Options({
  components: {
    Page,
    ActionButton,
    Table,
    Datepicker
  }
})
export default class AccessLogs extends Vue {
  accessLogs: AccessLog[] = [];
  header = [
    { title: "日時", sortable: true, key: "datetime", width: "expand" },
    { title: "画面", sortable: true, key: "pageName", width: "expand" },
    { title: "従業員", sortable: true, key: "userFullName", width: "expand" },
    { title: "対象", sortable: true, key: "targetName", width: "expand" },
    { title: "操作", sortable: true, key: "action", width: "expand" }
  ];
  filterColumns = ["userFullName"];
  query = "";
  offset?: string;
  FormValues: FormValues = {};
  pageIds: PageId[] = [];
  locale = ja;

  async beforeMount() {
    const pageIds = await new AccessLogApi().getPageIds({});
    this.pageIds = pageIds.data;
  }

  async getTableData() {
    if (this.offset === null) {
      return [];
    }
    const response = await new AccessLogApi().getAccessLogs(
      Object.assign({
        startDate: this.FormValues.startDate ? moment(this.FormValues.startDate).format("YYYY-MM-DD") : undefined,
        endDate: this.FormValues.endDate ? moment(this.FormValues.endDate).format("YYYY-MM-DD") : undefined,
        name: this.FormValues.name ? this.FormValues.name : undefined,
        pageId: this.FormValues.pageId ? this.FormValues.pageId : undefined,
        offset: this.offset ? this.offset : undefined
      })
    );
    this.offset = response.data.offset;
    if (!response.data.lists || !response.data.lists.length) return [];
    return response.data.lists.map(datum =>
      Object.assign(datum, {
        datetime: datum.datetime ? moment(datum.datetime).format("YYYY/MM/DD HH:mm") : "-",
        userFullName: datum.userFullName || "-",
        pageName: datum.pageName || "-",
        targetName: datum.targetName || "-",
        action: datum.action || "-"
      })
    );
  }
  onAccessLogSearch() {
    const table = this.$refs.tableComponent as Table;
    if (table) {
      this.offset = undefined;
      table.reset();
    }
  }
  async onSubmitted() {
    await new AuthApi().authenticate({}).then(resp => {
      if (resp.status === 200) {
        Store.getInstance().setAuth(resp.data);
      }
    });
    this.onAccessLogSearch();
  }

  resetConditions() {
    this.FormValues = {};
    this.onAccessLogSearch();
  }
}
</script>
